/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'hefty',
    quality: 0,
    damageMod: 0.05,
    speed: -0.5
}